/* Sticky "Seleccionar talla" button */
document.addEventListener('DOMContentLoaded', () => {

  // Solo en móvil
  if (window.innerWidth >= 750) return;

  const originalButton = document.querySelector(
    'add-to-cart-component button[name="add"]'
  );

  const sticky = document.getElementById('MobileStickyATC');
  const stickyButton = document.getElementById('MobileStickyATCButton');

  if (!originalButton || !sticky || !stickyButton) return;

  // Mostrar u ocultar el botón flotante según la visibilidad
  // del botón original de "Añadir al carrito"
  const observer = new IntersectionObserver(([entry]) => {
    sticky.classList.toggle('is-visible', !entry.isIntersecting);
  }, {
    threshold: 0
  });

  observer.observe(originalButton);

  // Al pulsar, hacer scroll hasta la selección de talla
  stickyButton.addEventListener('click', () => {
    const variantWrapper = document.querySelector('.variant-option__wrapper');

    if (!variantWrapper) return;

    const headerOffset = 120; // Ajusta este valor si tu cabecera tiene otra altura
    const elementPosition =
      variantWrapper.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementPosition - headerOffset,
      behavior: 'smooth'
    });
  });

});